import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getManualSections, getManualSection } from 'library/manual/get';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemText,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  content: {
    minHeight: '60vh',
  },
  sections: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  markdown: {
    '& h1': { marginTop: 0 },
    '& table': { borderCollapse: 'collapse', margin: '1em 0' },
    '& th, & td': {
      border: `1px solid ${theme.palette.divider}`,
      padding: '.4em .8em',
      textAlign: 'left',
    },
  },
}));

export default function ManualModal({active, onClose}) {
  const classes = useStyles();
  const [sections, setSections] = React.useState([]);
  const [selected, setSelected] = React.useState(null);
  const [section, setSection] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (!active || sections.length) return;
    getManualSections().then(x => {
      if (x.sections) {
        setSections(x.sections);
        if (x.sections.length) setSelected(x.sections[0].slug);
      } else {
        setError(x.error || "Couldn't load the manual");
      }
    });
  }, [active, sections.length]);

  React.useEffect(() => {
    if (!selected) return;
    setSection(null);
    getManualSection(selected).then(x => {
      if (x.content !== undefined) {
        setSection(x);
      } else {
        setError(x.error || "Couldn't load the section");
      }
    });
  }, [selected]);

  return (
    <Dialog open={active} onClose={onClose} maxWidth="md" fullWidth aria-labelledby="manual-dialog-title">
      <DialogTitle id="manual-dialog-title">User manual</DialogTitle>
      <DialogContent dividers className={classes.content}>
        {error ? error : (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} className={classes.sections}>
              <List dense>
                {sections.map(x => (
                  <ListItem button key={x.slug} selected={x.slug === selected} onClick={e => setSelected(x.slug)}>
                    <ListItemText primary={x.title} />
                  </ListItem>
                ))}
              </List>
            </Grid>
            <Grid item xs={12} sm={8} className={classes.markdown}>
              {section
                ? <ReactMarkdown remarkPlugins={[remarkGfm]}>{section.content}</ReactMarkdown>
                : <CircularProgress size={24} />}
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
